export default class TagCreateCtrl {
    construct($filter, SideMenu, Tag, Events) {
        SideMenu.setActive('tag');
        
        this.tagRepo = Tag;
        this.eventHandler = Events;
        this._filter = $filter;
        this.tagName = '';
    }
    
    saveTag() {
        this.tagRepo.store(this.tagName).then(() => {
            this.eventHandler.flashEvent(
                'notification',
                this._filter('translate')('TAG:FLASH:CREATE').replace(/:name/,  this.tagName)
            );
        }, () => {
            this.eventHandler.flashEvent(
                'error',
                this._filter('translate')('TAG:FLASH:UPDATE_DUPLICATE').replace(/:name/,  this.tag.name)
            );
        }); 
    }
}

TagCreateCtrl.$inject = ['$filter', 'SideMenu', 'Tag', 'Events'];